import { doc, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Brand } from "../types";

export const getBrandById = async (brandId: string): Promise<Brand> => {
  const docRef = doc(db, "brands", brandId);

  const brandSnapshot = await getDoc(docRef);

  return { ...brandSnapshot.data(), id: brandSnapshot.id } as Brand;
};
